import { render } from "./OrderInfo.vue?vue&type=template&id=1a4e345a&scoped=true&ts=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"

import "./OrderInfo.vue?vue&type=style&index=0&id=1a4e345a&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e345a"]])

export default __exports__